/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Save_To_JobsInputs */

const en_jobs_save_to_jobs = /** @type {(inputs: Jobs_Save_To_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save to Jobs`)
};

const de_jobs_save_to_jobs = /** @type {(inputs: Jobs_Save_To_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Stellen speichern`)
};

const fr_jobs_save_to_jobs = /** @type {(inputs: Jobs_Save_To_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer dans les emplois`)
};

const es_jobs_save_to_jobs = /** @type {(inputs: Jobs_Save_To_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar en empleos`)
};

const it_jobs_save_to_jobs = /** @type {(inputs: Jobs_Save_To_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva nei lavori`)
};

const nl_jobs_save_to_jobs = /** @type {(inputs: Jobs_Save_To_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opslaan bij banen`)
};

const pl_jobs_save_to_jobs = /** @type {(inputs: Jobs_Save_To_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapisz w ofertach`)
};

const fi_jobs_save_to_jobs = /** @type {(inputs: Jobs_Save_To_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tallenna työpaikkoihin`)
};

const da_jobs_save_to_jobs = /** @type {(inputs: Jobs_Save_To_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gem til job`)
};

const sv_jobs_save_to_jobs = /** @type {(inputs: Jobs_Save_To_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spara till jobb`)
};

/**
* | output |
* | --- |
* | "Save to Jobs" |
*
* @param {Jobs_Save_To_JobsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_save_to_jobs = /** @type {((inputs?: Jobs_Save_To_JobsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Save_To_JobsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_save_to_jobs(inputs)
	if (locale === "fr") return fr_jobs_save_to_jobs(inputs)
	if (locale === "es") return es_jobs_save_to_jobs(inputs)
	if (locale === "it") return it_jobs_save_to_jobs(inputs)
	if (locale === "nl") return nl_jobs_save_to_jobs(inputs)
	if (locale === "pl") return pl_jobs_save_to_jobs(inputs)
	if (locale === "fi") return fi_jobs_save_to_jobs(inputs)
	if (locale === "da") return da_jobs_save_to_jobs(inputs)
	if (locale === "sv") return sv_jobs_save_to_jobs(inputs)
	return en_jobs_save_to_jobs(inputs)
});